/* "+ Add" on the side cart's suggestions.

   The piece goes in through the cart API with the drawer rendered in the
   same request, and that is handed to cart-drawer's own renderContents —
   the path the product form takes — so the line, the total, the count and
   the suggestions (now without the piece just added) refresh together.

   A piece without sizes has a plain button. A piece with sizes has a list
   dressed as the same button: opening it shows the sizes, and choosing one
   adds that size, so a size is never guessed and the card needs no second
   control. */
class NvCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button.nv-upsell__add');
      if (button) this.add(button, button.dataset.variantId);
    });

    /* The suggestions sit inside cart-drawer-items, which treats every change
       event within it as a quantity edit and fails on anything else. A size
       choice is not one, so it stops here. */
    this.addEventListener('change', (event) => {
      event.stopPropagation();
      const pick = event.target.closest('.nv-upsell__pick');
      if (pick && pick.value) this.add(pick, pick.value);
    });
  }

  async add(control, id) {
    const card = control.closest('.nv-upsell__card');
    const error = card.querySelector('.nv-upsell__error');
    const drawer = document.querySelector('cart-drawer');

    control.disabled = true;
    control.setAttribute('aria-busy', 'true');
    error.hidden = true;

    try {
      const response = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(id),
          quantity: 1,
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add this piece.');

      // The header's count listens for this; the drawer itself is redrawn below.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv-cart-upsell', productVariantId: id, cartData: state });
      }
      drawer.renderContents(state);
    } catch (err) {
      error.textContent = err.message;
      error.hidden = false;
      control.disabled = false;
      control.removeAttribute('aria-busy');
      if (control.tagName === 'SELECT') control.value = '';
    }
  }
}

if (!customElements.get('nv-cart-upsell')) customElements.define('nv-cart-upsell', NvCartUpsell);
